(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["authority-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────── */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function isMobile() { return window.innerWidth < 750; }

  /* ── Init all authority-bar auto-scroll sections ── */
  var sections = document.querySelectorAll('[data-authority-auto-scroll="true"]');
  if (!sections.length) return;

  sections.forEach(function (el) {
    var track = el.querySelector('.authority-bar__track');
    if (!track) return;

    var speed       = parseFloat(el.getAttribute('data-auto-scroll-speed')) || 30;
    var doPause     = el.getAttribute('data-auto-scroll-pause') !== 'false';
    var resumeDelay = parseInt(el.getAttribute('data-auto-scroll-resume-delay'), 10) || 2500;

    /* ── Clone management for seamless infinite loop ── */
    var originals    = Array.from(track.children);
    var clones       = [];
    var cloned       = false;
    var contentWidth = 0;

    function cloneOnce(src) {
      var c = src.cloneNode(true);
      c.setAttribute('data-autoscroll-clone', '');
      c.removeAttribute('id');
      Array.from(c.attributes).forEach(function (a) {
        if (a.name.indexOf('data-shopify') === 0) c.removeAttribute(a.name);
      });
      track.appendChild(c);
      clones.push(c);
    }

    function addClones() {
      if (cloned) return;

      /*
       * We need enough cloned copies so that:
       *   track.scrollWidth − track.clientWidth  >=  originalContentWidth
       *
       * Otherwise scrollLeft physically can't reach the loop-reset point
       * because the browser caps it at (scrollWidth − clientWidth).
       *
       * Formula:  copies >= ceil( viewport / origWidth ) + 1
       * The +1 guarantees headroom even if items are narrower than the screen.
       */
      var origWidth = track.scrollWidth;
      var viewWidth = track.clientWidth;
      var copies    = Math.max(2, Math.ceil(viewWidth / Math.max(origWidth, 1)) + 1);

      for (var i = 0; i < copies; i++) {
        originals.forEach(function (child) { cloneOnce(child); });
      }

      cloned = true;
      measure();
    }

    function removeClones() {
      clones.forEach(function (c) { if (c.parentNode) c.parentNode.removeChild(c); });
      clones       = [];
      cloned       = false;
      contentWidth = 0;
    }

    function measure() {
      /*
       * The loop point = the left edge of the FIRST clone.
       * getBoundingClientRect gives us its visual position; adding
       * the current scrollLeft converts it to an absolute scroll offset.
       */
      if (!clones.length) return;
      var trackRect = track.getBoundingClientRect();
      var cloneRect = clones[0].getBoundingClientRect();
      contentWidth  = Math.round(cloneRect.left - trackRect.left + track.scrollLeft);
    }

    /* ── Animation state ─────────────────────────── */
    var paused      = false;
    var resumeTimer = null;
    var lastTs      = null;
    var rafId       = null;
    var running     = false;

    function step(ts) {
      if (!running) return;

      /* Idle when not on mobile or paused */
      if (!isMobile() || paused || reducedMotion.matches) {
        lastTs = null;
        rafId = requestAnimationFrame(step);
        return;
      }

      /* Ensure clones exist */
      if (!cloned) {
        addClones();
        lastTs = null;
        rafId = requestAnimationFrame(step);
        return;
      }

      if (!lastTs) lastTs = ts;
      var dt = (ts - lastTs) / 1000;
      lastTs = ts;

      /* Safety: if measurement failed, retry */
      if (contentWidth <= 0) {
        measure();
        rafId = requestAnimationFrame(step);
        return;
      }

      track.scrollLeft += speed * dt;

      /*
       * Seamless loop: once we scroll past one full set of originals,
       * subtract exactly that distance. Because the cloned content is
       * visually identical, the user sees no jump.
       */
      if (track.scrollLeft >= contentWidth) {
        track.scrollLeft -= contentWidth;
      }

      rafId = requestAnimationFrame(step);
    }

    function start() {
      if (running) return;
      running = true;
      if (isMobile()) addClones();
      rafId = requestAnimationFrame(step);
    }

    function stop() {
      running = false;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      lastTs = null;
    }

    /* ── Responsive: add/remove clones on breakpoint change ── */
    function handleResize() {
      if (isMobile()) {
        if (!cloned) addClones();
      } else {
        if (cloned) {
          removeClones();
          track.scrollLeft = 0;
        }
      }
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        handleResize();
        if (cloned) measure();
      }, 120);
    }, { passive: true });

    /* ── Pause / resume on user interaction ──────── */
    if (doPause) {
      var pauseFn = function () {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
      };
      var resumeFn = function () {
        resumeTimer = setTimeout(function () {
          lastTs = null;   /* Prevent a big delta jump on resume */
          paused = false;
        }, resumeDelay);
      };

      track.addEventListener('touchstart',  pauseFn,  { passive: true });
      track.addEventListener('touchend',    resumeFn, { passive: true });
      track.addEventListener('pointerdown', pauseFn,  { passive: true });
      track.addEventListener('pointerup',   resumeFn, { passive: true });
    }

    /* ── Reduced-motion: start/stop dynamically ──── */
    reducedMotion.addEventListener('change', function (e) {
      if (e.matches) { stop(); removeClones(); track.scrollLeft = 0; }
      else { start(); }
    });

    /* ── Go ──────────────────────────────────────── */
    if (!reducedMotion.matches) start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jyg-topbar"] && !Shopify.designMode) return;
  try {
    
  class JygTopbar {
    constructor(root) {
      this.root = root;
      this.mode = root.dataset.mode;
      this.pauseOnHover = root.dataset.pauseHover === 'true';
      this.hideArrowsMobile = root.dataset.hideArrowsMobile === 'true';
      this.slides = Array.from(root.querySelectorAll('[data-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-dot]'));
      this.prev = root.querySelector('[data-prev]');
      this.next = root.querySelector('[data-next]');
      this.track = root.querySelector('[data-track]');
      this.index = 0;
      this.timer = null;
      this.visible = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mqMobile = window.matchMedia('(max-width: 749px)');

      this.bind();
      this.applyMode();
      if (this.mode === 'marquee') this.bindMarquee();
      this.watchVisibility();
      this.watchViewport();
    }

    // True when carousel should auto-rotate.
    // Auto mode → always. Manual mode → only on mobile when arrows are hidden there.
    shouldAutoRotate() {
      if (this.mode === 'auto') return true;
      if (this.mode === 'manual' && this.hideArrowsMobile && this.mqMobile.matches) return true;
      return false;
    }

    applyMode() {
      if (this.shouldAutoRotate()) this.startAuto();
      else this.stopAuto();
    }

    watchViewport() {
      const handler = () => this.applyMode();
      if (this.mqMobile.addEventListener) {
        this.mqMobile.addEventListener('change', handler);
      } else if (this.mqMobile.addListener) {
        this.mqMobile.addListener(handler);
      }
      this.mqHandler = handler;
    }

    bind() {
      if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.dot, 10), true)));

      if (this.pauseOnHover && this.mode !== 'manual') {
        this.root.addEventListener('mouseenter', () => this.pause());
        this.root.addEventListener('mouseleave', () => this.resume());
        this.root.addEventListener('focusin', () => this.pause());
        this.root.addEventListener('focusout', () => this.resume());
      }

      // Touch swipe for auto/manual
      if (this.mode !== 'marquee' && this.track) {
        let startX = 0;
        let dx = 0;
        this.track.addEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
          dx = 0;
          this.pause();
        }, { passive: true });
        this.track.addEventListener('touchmove', (e) => {
          dx = e.touches[0].clientX - startX;
        }, { passive: true });
        this.track.addEventListener('touchend', () => {
          if (Math.abs(dx) > 40) {
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          }
          this.resume();
        });
      }

      // Pause when tab hidden (battery)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.resume();
      });
    }

    watchVisibility() {
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.visible = entry.isIntersecting;
          if (!this.visible) this.pause();
          else this.resume();
        });
      }, { threshold: 0 });
      io.observe(this.root);
      this.io = io;
    }

    go(targetIndex, userInitiated) {
      if (!this.slides.length) return;
      const n = this.slides.length;
      const i = ((targetIndex % n) + n) % n;
      this.slides[this.index].classList.remove('is-active');
      this.slides[this.index].setAttribute('aria-hidden', 'true');
      this.slides[i].classList.add('is-active');
      this.slides[i].removeAttribute('aria-hidden');
      this.dots.forEach((d, idx) => {
        const active = idx === i;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.index = i;
      if (userInitiated && this.shouldAutoRotate()) this.restartAuto();
    }

    startAuto() {
      if (this.reducedMotion) return;
      if (this.slides.length <= 1) return;
      const isMobile = this.mqMobile.matches;
      const cssVar = isMobile ? '--tb-auto-m' : '--tb-auto-d';
      const seconds = parseFloat(getComputedStyle(this.root).getPropertyValue(cssVar)) || 5;
      this.stopAuto();
      this.timer = setInterval(() => {
        if (this.visible && !document.hidden && !this.paused) {
          this.go(this.index + 1, false);
        }
      }, seconds * 1000);
    }

    stopAuto() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    restartAuto() { if (this.shouldAutoRotate()) { this.stopAuto(); this.startAuto(); } }

    bindMarquee() {
      // pause_on_hover for marquee is handled via data-paused attr
      if (!this.pauseOnHover) return;
      const toggle = (state) => this.root.setAttribute('data-paused', state ? 'true' : 'false');
      this.root.addEventListener('mouseenter', () => toggle(true));
      this.root.addEventListener('mouseleave', () => toggle(false));
      this.root.addEventListener('focusin', () => toggle(true));
      this.root.addEventListener('focusout', () => toggle(false));
    }

    pause() {
      this.paused = true;
      if (this.mode === 'marquee') this.root.setAttribute('data-paused', 'true');
    }
    resume() {
      this.paused = false;
      if (this.mode === 'marquee' && this.pauseOnHover === false) this.root.setAttribute('data-paused', 'false');
      else if (this.mode === 'marquee') this.root.setAttribute('data-paused', 'false');
    }

    destroy() {
      this.stopAuto();
      if (this.io) this.io.disconnect();
      if (this.mqHandler) {
        if (this.mqMobile.removeEventListener) {
          this.mqMobile.removeEventListener('change', this.mqHandler);
        } else if (this.mqMobile.removeListener) {
          this.mqMobile.removeListener(this.mqHandler);
        }
      }
    }
  }

  const instances = new WeakMap();

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-jyg-topbar]').forEach((el) => {
      if (!instances.has(el)) instances.set(el, new JygTopbar(el));
    });
  }

  function destroyIn(scope) {
    (scope || document).querySelectorAll('[data-jyg-topbar]').forEach((el) => {
      const inst = instances.get(el);
      if (inst) { inst.destroy(); instances.delete(el); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Shopify editor lifecycle
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => destroyIn(e.target));
  document.addEventListener('shopify:section:select', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest('[data-jyg-topbar]');
    if (!root) return;
    const inst = instances.get(root);
    const slide = e.target.closest('[data-slide]');
    if (inst && slide) inst.go(parseInt(slide.dataset.slide, 10), true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shore-pro-bento"] && !Shopify.designMode) return;
  try {
    
  // Bento behaviour:
  //   1. Pause native videos when off-screen (battery, mobile data).
  //   2. Optional auto-center: when a row's spans sum to less than the column
  //      count, center the row by setting `grid-column: <offset> / span <n>`
  //      on its first card.
  (function () {
    // --- AUTO-CENTER INCOMPLETE ROWS ---------------------------------------
    // Linear walk that sums column spans to figure out which cards land in
    // which row, then centers any row whose total span is < column count.
    //
    // Skipped when any card has row-span > 1: a 1D sum can't replicate CSS
    // Grid's 2D dense packing, so explicit column offsets would overlap the
    // row-spanning card.
    const centerRows = (root) => {
      const grid = root.querySelector('.jyg-bento__grid');
      if (!grid) return;
      const cards = Array.from(grid.children).filter((c) =>
        c.classList && c.classList.contains('jyg-bento__card')
      );
      if (!cards.length) return;

      // Reset previous placements before recomputing (toggling off or resizes
      // across breakpoints would otherwise leave stale grid-column values).
      cards.forEach((c) => {
        c.style.gridColumn = '';
        c.style.gridColumnStart = '';
      });

      if (root.dataset.autoCenter !== 'true') return;

      // Resolve the active breakpoint to one set of CSS variable names.
      const bp = (() => {
        if (window.matchMedia('(max-width: 749px)').matches) {
          return { spanVar: '--span-m', rowVar: '--row-m', colsVar: '--bn-cols-m', fallbackSpan: 12 };
        }
        if (window.matchMedia('(max-width: 1024px)').matches) {
          return { spanVar: '--span-t', rowVar: '--row-d', colsVar: '--bn-cols-t', fallbackSpan: 6 };
        }
        return { spanVar: '--span-d', rowVar: '--row-d', colsVar: '--bn-cols-d', fallbackSpan: 6 };
      })();

      const hasRowSpan = cards.some((c) => {
        const r = parseInt(c.style.getPropertyValue(bp.rowVar), 10) || 1;
        return r > 1;
      });
      if (hasRowSpan) return;

      const cols = parseInt(getComputedStyle(root).getPropertyValue(bp.colsVar), 10) || 12;

      // rowFirstSpan is tracked so closeRow() can emit the full
      // `<start> / span <span>` shorthand — unambiguous placement that CSS
      // Grid won't try to re-flow elsewhere.
      let rowSum = 0;
      let rowStart = 0;
      let rowFirstSpan = 0;
      const closeRow = (endIndex) => {
        if (rowSum > 0 && rowSum < cols && rowStart <= endIndex) {
          const offset = Math.floor((cols - rowSum) / 2) + 1;
          if (offset > 1) {
            cards[rowStart].style.gridColumn = offset + ' / span ' + rowFirstSpan;
          }
        }
      };

      for (let i = 0; i < cards.length; i++) {
        const raw = cards[i].style.getPropertyValue(bp.spanVar).trim();
        const span = Math.min(cols, parseInt(raw, 10) || bp.fallbackSpan);
        if (rowSum + span > cols) {
          closeRow(i - 1);
          rowSum = span;
          rowStart = i;
          rowFirstSpan = span;
        } else {
          if (rowSum === 0) {
            rowStart = i;
            rowFirstSpan = span;
          }
          rowSum += span;
        }
      }
      closeRow(cards.length - 1);
    };

    // --- VIDEO PAUSE-ON-VIEWPORT ------------------------------------------
    const initVideos = (root) => {
      const videos = root.querySelectorAll('video.jyg-bento__video');
      if (!videos.length || !('IntersectionObserver' in window)) return null;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting && v.autoplay && v.paused) {
            const p = v.play();
            if (p && typeof p.catch === 'function') p.catch(() => {});
          } else if (!e.isIntersecting && !v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.1 });
      videos.forEach((v) => io.observe(v));
      return io;
    };

    // --- LIFECYCLE --------------------------------------------------------
    const debounce = (fn, ms) => {
      let t;
      return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
    };

    const init = (root) => {
      if (root.dataset.jygBentoInit === '1') return;
      root.dataset.jygBentoInit = '1';

      root._jygBentoIo = initVideos(root);
      requestAnimationFrame(() => centerRows(root));

      const onResize = debounce(() => centerRows(root), 150);
      window.addEventListener('resize', onResize);
      root._jygBentoResize = onResize;
    };

    const initAll = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bento]').forEach(init);
    };
    const teardown = (scope) => {
      (scope || document).querySelectorAll('[data-jyg-bento]').forEach((root) => {
        if (root._jygBentoIo) { root._jygBentoIo.disconnect(); delete root._jygBentoIo; }
        if (root._jygBentoResize) {
          window.removeEventListener('resize', root._jygBentoResize);
          delete root._jygBentoResize;
        }
        delete root.dataset.jygBentoInit;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load',   (e) => initAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
    document.addEventListener('shopify:section:select', (e) => initAll(e.target));
    document.addEventListener('shopify:block:added',    (e) => {
      const root = e.target.closest && e.target.closest('[data-jyg-bento]');
      if (root) requestAnimationFrame(() => centerRows(root));
    });
    document.addEventListener('shopify:block:removed',  () => {
      document.querySelectorAll('[data-jyg-bento]').forEach((root) => {
        requestAnimationFrame(() => centerRows(root));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
